import React, { useEffect, useState, useCallback } from "react";
import "./DashboardModern.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";





import io from "socket.io-client";
import QRCode from "react-qr-code";


// ================= CONSTANTS =================
const CHAINS = [
  { name: "SOLANA", logo: "/logos/coins/solana.svg", color: "#22c55e" },
  { name: "BSC", logo: "/logos/coins/bsc.svg", color: "#facc15" },
  { name: "ETH", logo: "/logos/coins/eth.svg", color: "#60a5fa" },
  { name: "POLYGON", logo: "/logos/coins/polygon.svg", color: "#a855f7" },
];

const INVESTMENT_PLANS = [
  { days: 7, user: 50, admin: 50 },
  { days: 30, user: 55, admin: 45 },
  { days: 100, user: 60, admin: 40 },
  { days: 180, user: 70, admin: 30 },
  { days: 365, user: 80, admin: 20 },
];

const BOT_PLANS = [
  {
    id: "basic",
    name: "Basic",
    price: 50,
    features: ["24/7 Trading", "Low Risk", "1 Exchange"],
  },
  {
    id: "pro",
    name: "Pro",
    price: 150,
    features: ["24/7 Trading", "Medium Risk", "3 Exchanges", "Leverage 5x"],
  },
  {
    id: "premium",
    name: "Premium",
    price: 300,
    features: [
      "24/7 Trading",
      "High Risk",
      "5 Exchanges",
      "Leverage 10x",
      "Priority Signals",
    ],
  },
];

// ================= STYLES =================
const earningText = {
  label: {
    color: "#9ca3af",
    fontSize: 14,
    marginBottom: 4,
    letterSpacing: "0.3px",
  },
  value: {
    color: "#22c55e",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: "0.4px",
    textShadow: "0 0 10px rgba(34,197,94,0.45)",
  },
};

const styles = {
  page: {
    background: "#020617",
    color: "#cbd5e1",
    padding: 20,
    minHeight: "100vh",
  },
  title: {
    textAlign: "center",
    color: "#22c55e",
    marginBottom: 24,
    fontSize: 28,
  },
  socketAlert: {
    background: "#ef4444",
    color: "#fff",
    padding: 12,
    borderRadius: 8,
    textAlign: "center",
    marginBottom: 20,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 16,
    marginBottom: 20,
  },
  box: {
    background: "#0f172a",
    padding: 16,
    borderRadius: 12,
    textAlign: "center",
    border: "1px solid #1e293b",
  },
  card: {
    marginTop: 20,
    background: "#0f172a",
    padding: 20,
    borderRadius: 16,
    border: "1px solid #1e293b",
  },
  actions: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    margin: "20px 0",
  },
  primaryBtn: {
    padding: 14,
    background: "#22c55e",
    border: "none",
    borderRadius: 10,
    fontWeight: "bold",
    cursor: "pointer",
    color: "#fff",
  },
  withdrawBtn: {
    padding: 14,
    background: "#22c55e",
    border: "none",
    borderRadius: 12,
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: 16,
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(34, 197, 94, 0.4)",
  },
  dangerBtn: {
    padding: 14,
    background: "#ef4444",
    border: "none",
    borderRadius: 10,
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
  },
  marketGrid: {
    marginTop: 30,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 20,
  },
  chainCard: {
    background: "#0f172a",
    padding: 16,
    borderRadius: 16,
    border: "1px solid #1e293b",
  },
  chainHeader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    marginBottom: 10,
  },
  signalHeader: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 12,
    opacity: 0.7,
    padding: "8px 0",
    borderBottom: "1px solid #1e293b",
  },
  trade: {
    display: "flex",
    justifyContent: "space-between",
    padding: "6px 0",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    background: "#0b5ed7",
    padding: 24,
    borderRadius: 16,
    width: "90%",
    maxWidth: 450,
    color: "#22c55e",
  },
  modalTitle: {
    marginBottom: 20,
    fontSize: 20,
    textAlign: "center",
  },
  qrBox: {
    background: "#fff",
    padding: 12,
    borderRadius: 8,
    display: "flex",
    justifyContent: "center",
    margin: "15px 0",
  },
  addressBox: {
    display: "flex",
    gap: 8,
    marginTop: 10,
  },
  addressInput: {
    flex: 1,
    padding: 10,
    background: "#000",
    color: "#22c55e",
    border: "1px solid #1e293b",
    borderRadius: 6,
  },
  referralBox: {
    display: "flex",
    gap: 8,
    marginTop: 10,
  },
  referralInput: {
    flex: 1,
    padding: 10,
    background: "#000",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
  },
  inputGroup: {
    marginBottom: 15,
  },
  input: {
    width: "100%",
    padding: 12,
    background: "#000",
    color: "#22c55e",
    border: "1px solid #1e293b",
    borderRadius: 6,
  },
  confirmBtn: {
    width: "100%",
    padding: 14,
    background: "#22c55e",
    border: "none",
    borderRadius: 10,
    fontWeight: "bold",
    color: "#fff",
    cursor: "pointer",
    marginTop: 10,
  },
  botPlan: {
    background: "#020617",
    padding: 15,
    borderRadius: 10,
    border: "1px solid #1e293b",
    marginBottom: 15,
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "#020617",
    color: "white",
  },
  loadingSpinner: {
    width: 50,
    height: 50,
    border: "4px solid rgba(34, 197, 94, 0.3)",
    borderRadius: "50%",
    borderTopColor: "#22c55e",
    animation: "spin 1s ease-in-out infinite",
    margin: "0 auto 15px",
  },
  copyBtn: {
    padding: "10px 15px",
    background: "#22c55e",
    border: "none",
    borderRadius: 6,
    color: "#fff",
    cursor: "pointer",
  },
  // Team-related styles
  teamHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  teamViewBtn: {
    padding: "6px 12px",
    background: "#3b82f6",
    border: "none",
    borderRadius: 6,
    color: "#fff",
    fontSize: 12,
    cursor: "pointer",
  },
  teamTabs: {
    display: "flex",
    gap: 8,
    marginBottom: 15,
  },
  teamTabBtn: {
    flex: 1,
    padding: "8px 12px",
    border: "none",
    borderRadius: 6,
    color: "#fff",
    fontSize: 14,
    cursor: "pointer",
  },
  teamList: {
    maxHeight: 300,
    overflowY: "auto",
    marginTop: 10,
  },
  teamMember: {
    background: "#0f172a",
    padding: 12,
    borderRadius: 8,
    marginBottom: 8,
    border: "1px solid #1e293b",
  },
  memberInfo: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  memberName: {
    fontWeight: "bold",
    color: "#cbd5e1",
  },
  memberId: {
    fontSize: 12,
    color: "#9ca3af",
  },
  memberStats: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 12,
  },
  memberLevel: {
    color: "#facc15",
  },
  memberBusiness: {
    color: "#22c55e",
  },
  noMembers: {
    textAlign: "center",
    color: "#9ca3af",
    padding: 20,
  },
};


// ================= MOBILE MENU STYLES =================
if (typeof document !== "undefined" && !document.getElementById("algoxpo-mobile-menu-css")) {
  const style = document.createElement("style");
  style.id = "algoxpo-mobile-menu-css";
  style.innerHTML = `
    .ax-mobile-menu-btn {
      display: none;
      position: fixed;
      top: 58px;
      left: 14px;
      z-index: 10001;
      width: 44px;
      height: 44px;
      border: 1px solid rgba(34,197,94,.35);
      border-radius: 12px;
      background: rgba(7,16,31,.96);
      color: #22c55e;
      font-size: 24px;
      cursor: pointer;
      box-shadow: 0 8px 25px rgba(0,0,0,.35);
    }

    .ax-mobile-sidebar {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      width: 280px;
      z-index: 10000;
      background:
        linear-gradient(180deg,#07111f 0%,#020617 100%);
      border-right: 1px solid #1e293b;
      box-shadow: 15px 0 45px rgba(0,0,0,.45);
      transform: translateX(-105%);
      transition: transform .25s ease;
      overflow-y: auto;
      padding: 22px 16px;
    }

    .ax-mobile-sidebar.open {
      transform: translateX(0);
    }

    .ax-mobile-overlay {
      display: none;
      position: fixed;
      inset: 0;
      z-index: 9998;
      background: rgba(0,0,0,.65);
      backdrop-filter: blur(3px);
    }

    .ax-mobile-overlay.open {
      display: block;
    }

    .ax-mobile-logo {
      padding: 8px 8px 22px;
      border-bottom: 1px solid #1e293b;
      margin-bottom: 16px;
    }

    .ax-mobile-logo-title {
      color: #fff;
      font-size: 21px;
      font-weight: 900;
    }

    .ax-mobile-logo-subtitle {
      color: #22c55e;
      font-size: 10px;
      font-weight: 800;
      letter-spacing: 1.5px;
      margin-top: 4px;
    }

    .ax-mobile-close {
      float: right;
      border: 0;
      background: transparent;
      color: #94a3b8;
      font-size: 24px;
      cursor: pointer;
    }

    .ax-mobile-menu-item {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 13px 14px;
      margin-bottom: 7px;
      border: 1px solid transparent;
      border-radius: 11px;
      background: transparent;
      color: #cbd5e1;
      text-align: left;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
    }

    .ax-mobile-menu-item:hover,
    .ax-mobile-menu-item.active {
      background: rgba(34,197,94,.10);
      border-color: rgba(34,197,94,.20);
      color: #22c55e;
    }

    .ax-mobile-menu-icon {
      width: 24px;
      text-align: center;
      font-size: 18px;
    }

    .ax-mobile-menu-section {
      color: #64748b;
      font-size: 10px;
      font-weight: 900;
      letter-spacing: 1.2px;
      padding: 14px 10px 7px;
      text-transform: uppercase;
    }

    @media (max-width: 768px) {
      .ax-mobile-menu-btn {
        display: block;
      }

      .ax-dashboard-mobile-content {
        padding-left: 0 !important;
        padding-right: 0 !important;
      }

      .ax-mobile-safe-title {
        padding-left: 58px !important;
      }
    }

    @media (min-width: 769px) {
      .ax-mobile-sidebar,
      .ax-mobile-overlay {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(style);
}

// ================= TRADINGVIEW WIDGET =================
const TradingViewTicker = ({ position }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      symbols: [
        { proName: "BINANCE:BTCUSDT", title: "BTC" },
        { proName: "BINANCE:ETHUSDT", title: "ETH" },
        { proName: "BINANCE:SOLUSDT", title: "SOL" },
        { proName: "BINANCE:BNBUSDT", title: "BNB" },
      ],
      showSymbolLogo: true,
      colorTheme: "dark",
      isTransparent: true,
      displayMode: "adaptive",
      locale: "en",
    });

    const el = document.getElementById(`tv-${position}`);
    if (el) {
      el.innerHTML = "";
      el.appendChild(script);
    }
  }, [position]);

  return (
    <div
      id={`tv-${position}`}
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        height: 46,
        zIndex: 9999,
        background: "#020B10",
        top: position === "top" ? 0 : "auto",
        bottom: position === "bottom" ? 0 : "auto",
      }}
    />
  );
};


// ================= MOBILE MENU =================
const MobileMenu = ({ open, onClose, onNavigate, onLogout }) => {
  const item = (icon, label, action) => (
    <button
      type="button"
      className="ax-mobile-menu-item"
      onClick={() => {
        action();
        onClose();
      }}
    >
      <span className="ax-mobile-menu-icon">{icon}</span>
      <span>{label}</span>
    </button>
  );

  return (
    <>
      <button
        type="button"
        className="ax-mobile-menu-btn"
        onClick={() => onNavigate("menu")}
        aria-label="Open menu"
      >
        ☰
      </button>

      <div
        className={`ax-mobile-overlay ${open ? "open" : ""}`}
        onClick={onClose}
      />

      <aside className={`ax-mobile-sidebar ${open ? "open" : ""}`}>
        <div className="ax-mobile-logo">
          <button
            type="button"
            className="ax-mobile-close"
            onClick={onClose}
          >
            ×
          </button>

          <div className="ax-mobile-logo-title">
            AlgoXPO
          </div>

          <div className="ax-mobile-logo-subtitle">
            AI POWERED TRADING
          </div>
        </div>

        <div className="ax-mobile-menu-section">
          Main
        </div>

        {item("⌂", "Dashboard", () => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        })}

        {item("📊", "Investments", () => {
          const el = document.getElementById("ax-investments-section");
          if (el) el.scrollIntoView({ behavior: "smooth" });
        })}

        {item("💰", "Earnings", () => {
          const el = document.getElementById("ax-earnings-section");
          if (el) el.scrollIntoView({ behavior: "smooth" });
        })}

        {item("📋", "Transactions", () => {
          onNavigate("transactions");
        })}

        <div className="ax-mobile-menu-section">
          Account
        </div>

        {item("👥", "Team", () => {
          onNavigate("team");
        })}

        {item("💳", "Wallet", () => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        })}

        {item("🤖", "AI Trading Bot", () => {
          if (!open) return;

          if (!onNavigate("bot")) {
            return;
          }
        })}

        {item("🥇", "Gold Trading", () => {
          window.location.href = "/gold-trading";
        })}

        {item("₿", "BTC Trading", () => {
          window.location.href = "/btc-trading";
        })}

        {item("🔗", "Referral", () => {
          const el = document.getElementById("ax-referral-section");
          if (el) el.scrollIntoView({ behavior: "smooth" });
        })}

        <div className="ax-mobile-menu-section">
          Account
        </div>

        {item("⚙️", "Profile / Settings", () => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        })}

        <button
          type="button"
          className="ax-mobile-menu-item"
          onClick={() => {
            onClose();
            onLogout();
          }}
          style={{ color: "#ef4444" }}
        >
          <span className="ax-mobile-menu-icon">↪</span>
          <span>Logout</span>
        </button>
      </aside>
    </>
  );
};

// ================= BOX COMPONENT =================
const Box = ({ title, value, green }) => (
  <div style={styles.box}>
    <p style={earningText.label}>{title}</p>
    <h3 style={green ? earningText.value : { color: "#cbd5e1" }}>{value}</h3>
  </div>
);

// ================= TEAM MEMBER COMPONENT =================
const TeamMember = ({ userId, email, level = 0, openLevel = 0, business = 0 }) => (
  <div style={styles.teamMember}>
    <div style={styles.memberInfo}>
      <span style={styles.memberName}>{email}</span>
      <span style={styles.memberId}>ID: {userId}</span>
    </div>
    <div style={styles.memberStats}>
      <span style={styles.memberLevel}>
        L{openLevel || level}
      </span>
      <span style={styles.memberBusiness}>
        ${Number(business).toFixed(2)}
      </span>
    </div>
  </div>
);



// ================= MODAL COMPONENTS =================
const Modal = ({ children, onClose }) => (
  <div style={styles.overlay} onClick={onClose}>
    <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  </div>
);

const DepositModal = ({ address, onClose }) => (
  <Modal onClose={onClose}>
    <h3 style={styles.modalTitle}>Deposit Funds</h3>
    {address ? (
      <>
        <div style={styles.qrBox}>
          <QRCode value={address} size={128} />
        </div>
        <div style={styles.addressBox}>
          <input
            readOnly
            value={address}
            style={styles.addressInput}
          />
          <button
            style={styles.copyBtn}
            onClick={() => navigator.clipboard.writeText(address)}
          >
            Copy
          </button>
        </div>
      </>
    ) : (
      <p style={{ color: "#ef4444", textAlign: "center" }}>
        Failed to load deposit address.
      </p>
    )}
  </Modal>
);

const WithdrawModal = ({ balance, onClose, onSubmit }) => {
  const [amount, setAmount] = useState("");
  const [address, setAddress] = useState("");

  return (
    <Modal onClose={onClose}>
      <h3 style={styles.modalTitle}>Withdraw Earnings</h3>
      <div style={styles.inputGroup}>
        <label>Amount (Max: ${balance.toFixed(2)})</label>
        <input
          type="number"
          style={styles.input}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          max={balance}
        />
      </div>
      <div style={styles.inputGroup}>
        <label>BEP20 Address</label>
        <input
          type="text"
          style={styles.input}
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="0x..."
        />
      </div>
      <button
        style={styles.confirmBtn}
        onClick={() => onSubmit(amount, address)}
      >
        Confirm Withdrawal
      </button>
    </Modal>
  );
};

const InvestModal = ({ balance, onClose, onSubmit }) => {
  const [amount, setAmount] = useState("");
  const [days, setDays] = useState(7);

  return (
    <Modal onClose={onClose}>
      <h3 style={styles.modalTitle}>Create Investment Contract</h3>
      <div style={styles.inputGroup}>
        <label>Amount (USD)</label>
        <input
          type="number"
          style={styles.input}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          max={balance}
        />
      </div>
      <div style={styles.inputGroup}>
        <label>Lock Period (Days)</label>
        <select
          style={styles.input}
          value={days}
          onChange={(e) => setDays(Number(e.target.value))}
        >
          {INVESTMENT_PLANS.map((p) => (
            <option key={p.days} value={p.days}>
              {p.days} Days ({p.user}% User)
            </option>
          ))}
        </select>
      </div>
      <button
        style={styles.confirmBtn}
        onClick={() => onSubmit(amount, days)}
      >
        Confirm Investment
      </button>
    </Modal>
  );
};
const TransferModal = ({ balance, onClose, onSubmit }) => {
  const [receiverUserId, setReceiverUserId] = useState("");
  const [amount, setAmount] = useState("");

  return (
    <Modal onClose={onClose}>
      <h3 style={styles.modalTitle}>Wallet Transfer</h3>

      <div style={styles.inputGroup}>
        <label>Receiver User ID</label>
        <input
          type="text"
          style={styles.input}
          value={receiverUserId}
          onChange={(e) => setReceiverUserId(e.target.value)}
          placeholder="AX123456"
        />
      </div>

      <div style={styles.inputGroup}>
        <label>Amount (Max: ${balance.toFixed(2)})</label>
        <input
          type="number"
          style={styles.input}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          max={balance}
        />
      </div>

      <button
        style={styles.confirmBtn}
        onClick={() => onSubmit(receiverUserId, amount)}
      >
        Transfer Now
      </button>
    </Modal>
  );
};

const BotActivationModal = ({ balance, onClose, onSubmit }) => {
  const plan = BOT_PLANS[0];
  const canActivate = balance >= plan.price;

  return (
    <Modal onClose={onClose}>
      <h3 style={styles.modalTitle}>Activate Trading Bot</h3>
      <div style={styles.botPlan}>
        <h4>{plan.name} Plan</h4>
        <p>${plan.price} (One-time)</p>
        <ul>
          {plan.features.map((f, i) => (
            <li key={i}>✅ {f}</li>
          ))}
        </ul>
      </div>
      <button
        style={{
          ...styles.confirmBtn,
          background: canActivate ? "#22c55e" : "#6b7280",
          cursor: canActivate ? "pointer" : "not-allowed",
        }}
        onClick={() => canActivate && onSubmit()}
        disabled={!canActivate}
      >
        {canActivate ? "Activate Now" : "Insufficient Balance"}
      </button>
    </Modal>
  );
};



/* ================= EMAIL MASK ================= */

const maskEmail = (email = "") => {

  if (!email || !email.includes("@")) return "****";

  const [name, domain] = email.split("@");

  if (name.length <= 2) {

    return name.charAt(0) + "***@" + domain;

  }

  return (
    name.slice(0, 2) +
    "***" +
    name.slice(-2) +
    "@" +
    domain
  );

};

// ================= TEAM MODAL =================

const TeamModal = ({ directMembers = [], teamMembers = [], onClose }) => {

  const [activeTab, setActiveTab] = useState("direct");

  const renderMembers = (members) => {


    if (!members.length) {
      return (
        <p style={styles.noMembers}>
          No members found
        </p>
      );
    }

    return members.map((member, index) => (
      <TeamMember
        key={member.userId || index}
        userId={member.userId}
        email={maskEmail(member.email)}
        level={member.level || 0}
        business={member.contractValue || 0}
      />
    ));
  };

  return (
    <Modal onClose={onClose}>
      <h3 style={styles.modalTitle}>Your Team</h3>

      <div style={styles.teamTabs}>
        <button
          style={{
            ...styles.teamTabBtn,
            background: activeTab === "direct" ? "#22c55e" : "#1e293b",
          }}
          onClick={() => setActiveTab("direct")}
        >
          Direct ({directMembers.length})
        </button>

        <button
          style={{
            ...styles.teamTabBtn,
            background: activeTab === "team" ? "#22c55e" : "#1e293b",
          }}
          onClick={() => setActiveTab("team")}
        >
          Team ({teamMembers.length})
        </button>
      </div>

      <div style={styles.teamList}>
        {activeTab === "direct"
          ? renderMembers(directMembers)
          : renderMembers(teamMembers)}
      </div>
    </Modal>
  );
};

// ================= MAIN DASHBOARD =================
export default function Dashboard() {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [socketConnected, setSocketConnected] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [withdrawSuccess, setWithdrawSuccess] = useState(false);

  // ===== STATES =====
  const [walletBalance, setWalletBalance] = useState(0);
  const [earningBalance, setEarningBalance] = useState(0);
  const [directIncome, setDirectIncome] = useState(0);
  const [teamIncome, setTeamIncome] = useState(0);
  const [signals, setSignals] = useState([]);
  const [investments, setInvestments] = useState([]);
  const [depositAddress, setDepositAddress] = useState("");
  const [userBotStatus, setUserBotStatus] = useState(null);

  // ===== BTC AI BOT =====
  const [btcBotStatus, setBtcBotStatus] = useState(null);
  const [btcBotLoading, setBtcBotLoading] = useState(false);
  const [earnings, setEarnings] = useState({
    totalContract: 0,
    today: 0,
    yesterday: 0,
    totalEarned: 0,
  });
  const [isLoading, setIsLoading] = useState(true);

  // Transaction history
  const [history, setHistory] = useState({
    deposits: [],
    withdrawals: [],
    transfers: [],
    investments: [],
  });
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [historyFilter, setHistoryFilter] = useState("all");
  const [modals, setModals] = useState({
    deposit: false,
    withdraw: false,
    invest: false,
    bot: false,
    team: false,
  });
  const [contractValue, setContractValue] = useState(0);
  const [directMembers, setDirectMembers] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [directBusiness, setDirectBusiness] = useState(0);
  const [teamBusiness, setTeamBusiness] = useState(0);
  const [level, setLevel] = useState(0);

/* ================= ROI GRAPH ================= */

const [roiType, setRoiType] = useState("daily");

const [roiGraph, setRoiGraph] = useState([]);

const [roiTotal, setRoiTotal] = useState(0);
const loadRoiGraph = async (type = "daily") => {
  try {
    const res = await fetch(`/api/user/roi-graph?type=${type}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    if (data.success) {
      setRoiGraph(data.graph || []);
      setRoiTotal(data.totalRoi || 0);
    }
  } catch (err) {
    console.log("ROI GRAPH ERROR:", err);
  }
};


  // ===== BTC AI BOT CONTROLS =====
  const startBtcBot = async () => {
    if (btcBotLoading) return;

    try {
      setBtcBotLoading(true);

      const res = await fetch(
        "/api/demo-trading/btc/bot/start",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            quantity: 0.001,
          }),
        }
      );

      const data = await res.json();

      if (!res.ok || !data?.success) {
        throw new Error(
          data?.message || "Unable to start BTC AI Bot"
        );
      }

      setBtcBotStatus(data);

      console.log("₿ BTC AI BOT STARTED", data);
    } catch (error) {
      console.error("BTC BOT START ERROR:", error);
      alert(error.message || "Unable to start BTC AI Bot");
    } finally {
      setBtcBotLoading(false);
    }
  };

  const stopBtcBot = async () => {
    if (btcBotLoading) return;

    try {
      setBtcBotLoading(true);

      const res = await fetch(
        "/api/demo-trading/btc/bot/stop",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();

      if (!res.ok || !data?.success) {
        throw new Error(
          data?.message || "Unable to stop BTC AI Bot"
        );
      }

      setBtcBotStatus(data);

      console.log("₿ BTC AI BOT STOPPED", data);
    } catch (error) {
      console.error("BTC BOT STOP ERROR:", error);
      alert(error.message || "Unable to stop BTC AI Bot");
    } finally {
      setBtcBotLoading(false);
    }
  };

  // ===== SOCKET SETUP =====
  useEffect(() => {
    if (!userId) return;

    const socket = io(window.location.origin, {
      path: "/socket.io",
      transports: ["websocket"],
      reconnectionAttempts: 5,
      timeout: 20000,
    });

    socket.on("connect", () => {
      setSocketConnected(true);
      socket.emit("join", String(userId));
    });

    socket.on("balanceUpdated", (data) => {
      if (data.walletBalance !== undefined) setWalletBalance(data.walletBalance);
      if (data.earningBalance !== undefined) setEarningBalance(data.earningBalance);
    });

    socket.on("trading_signals", (liveSignals) => {
      if (Array.isArray(liveSignals)) setSignals(liveSignals);
    });

    socket.on("teamUpdated", (data) => {
      if (data.directMembers) setDirectMembers(data.directMembers);
      if (data.teamMembers) setTeamMembers(data.teamMembers);
      if (data.directBusiness !== undefined) setDirectBusiness(data.directBusiness);
      if (data.teamBusiness !== undefined) setTeamBusiness(data.teamBusiness);
      if (data.level !== undefined) setLevel(data.level);
    });

    socket.on("connect_error", (err) => {
      console.error("Socket error:", err);
      setSocketConnected(false);
    });

    return () => {
      socket.off("balanceUpdated");
      socket.off("trading_signals");
      socket.off("teamUpdated");
      socket.off("connect_error");
      socket.disconnect();
    };
  }, [userId]);

useEffect(() => {
    loadRoiGraph("daily");
  }, []);

  // ===== FAST LOAD DASHBOARD DATA =====
  const loadDashboard = useCallback(async () => {
    if (!token) return;

    try {
      setIsLoading(true);

      // 1. Load essential dashboard data first
      const dashboardRes = await fetch("/api/user/dashboard", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const dashboardData = await dashboardRes.json();

      if (dashboardData?.success) {
        const user = dashboardData.user;

        setWalletBalance(Number(user.walletBalance) || 0);
        setEarningBalance(Number(user.earningBalance) || 0);
        setDirectIncome(Number(user.directIncome) || 0);
        setTeamIncome(Number(user.teamIncome) || 0);
        setUserBotStatus(user.botStatus || null);

        // ===== LOAD BTC AI BOT STATUS =====
        try {
          const btcBotRes = await fetch(
            "/api/demo-trading/btc/bot/status",
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const btcBotData = await btcBotRes.json();

          if (btcBotData?.success) {
            setBtcBotStatus(btcBotData);
          } else {
            setBtcBotStatus(btcBotData || null);
          }
        } catch (btcError) {
          console.error("BTC BOT STATUS ERROR:", btcError);
          setBtcBotStatus(null);
        }

        setEarnings({
          totalContract: Number(user.contractValue) || 0,
          today: Number(user.todayEarnings) || 0,
          yesterday: Number(user.yesterdayEarnings) || 0,
          totalEarned: Number(user.earningBalance) || 0,
        });
      }

      // Main dashboard is ready
      setIsLoading(false);

      // 2. Load secondary data in background
      Promise.allSettled([
        fetch("/api/team/summary", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then(async (res) => {
          const data = await res.json();

          if (data?.success) {
            setDirectMembers(data.directMembers || []);
            setTeamMembers(data.teamMembers || []);

            setDirectBusiness(
              Number(data.summary?.directBusiness) || 0
            );

            setTeamBusiness(
              Number(data.summary?.totalTeamBusiness) || 0
            );

            setLevel(
              Number(data.summary?.myLevel) || 0
            );
          }
        }),

        fetch("/api/invest", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then(async (res) => {
          const data = await res.json();

          if (data?.success) {
            const list = Array.isArray(data.investments)
              ? data.investments
              : [];

            setInvestments(list);

            const totalContract = list.reduce(
              (acc, inv) => acc + (Number(inv.amount) || 0),
              0
            );

            setContractValue(totalContract);
          }
        }),

        fetch("/api/mev/signals").then(async (res) => {
          const data = await res.json();

          if (Array.isArray(data?.signals)) {
            setSignals(data.signals);
          }
        }),
      ]).catch((err) => {
        console.error("Background dashboard data error:", err);
      });

    } catch (err) {
      console.error("Dashboard load error:", err);

      setIsLoading(false);

      alert(
        "Failed to load dashboard data. Check console for details."
      );
    }
  }, [token]);


  // ===== LOAD TRANSACTION HISTORY IN BACKGROUND =====
  const loadHistory = useCallback(async () => {
    if (!token) return;

    try {
      setHistoryLoading(true);

      const res = await fetch("/api/user/history", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (data?.success) {
        setHistory({
          deposits: Array.isArray(data.deposits)
            ? data.deposits
            : [],
          withdrawals: Array.isArray(data.withdrawals)
            ? data.withdrawals
            : [],
          transfers: Array.isArray(data.transfers)
            ? data.transfers
            : [],
          investments: Array.isArray(data.investments)
            ? data.investments
            : [],
        });
      }
    } catch (err) {
      console.error("History load error:", err);
    } finally {
      setHistoryLoading(false);
    }
  }, [token]);

  // ===== HANDLERS =====
  const handleDeposit = async () => {
    try {
      const res = await fetch("/api/wallet/deposit-address", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data?.success) {
        setDepositAddress(data.depositAddress);
        setModals({ ...modals, deposit: true });
      } else {
        alert(data?.message || "Failed to fetch deposit address.");
      }
    } catch (err) {
      alert("Failed to fetch deposit address.");
    }
  };

  const handleWithdraw = async (amount, address) => {
    if (!amount || Number(amount) <= 0) return alert("Invalid amount");
    if (Number(amount) > earningBalance) return alert("Insufficient balance");
    if (!address || !address.startsWith("0x")) return alert("Invalid BEP20 address");

    try {
      const res = await fetch("/api/withdraw", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ amount, withdrawalAddress: address }),
      });
      const data = await res.json();
      if (data?.success) {
        alert("Withdrawal requested successfully!");
        setWithdrawSuccess(true);
        loadDashboard();
      } else {
        alert(data?.message || "Withdrawal failed.");
        setWithdrawSuccess(false);
      }
    } catch (err) {
      alert("Withdrawal error. Check console.");
      setWithdrawSuccess(false);
    } finally {
      setModals({ ...modals, withdraw: false });
    }
  };
const handleTransfer = async (receiverUserId, amount) => {
  if (!receiverUserId) return alert("Receiver User ID required");
  if (!amount || Number(amount) <= 0) return alert("Invalid amount");
  if (Number(amount) > earningBalance) return alert("Insufficient Earning Balance");

  try {
    const res = await fetch("/api/internal-transfer", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        receiverUserId,
        amount: Number(amount),
      }),
    });

    const data = await res.json();

    if (data?.success) {
      alert("Wallet Transfer Successful");
      loadDashboard();
    } else {
      alert(data?.message || "Transfer failed");
    }
  } catch (err) {
    alert("Transfer Failed");
  } finally {
    setModals({ ...modals, transfer: false });
  }
};

  const handleInvest = async (amount, days) => {
    if (!amount || Number(amount) <= 0) return alert("Invalid amount");
    if (Number(amount) > walletBalance) return alert("Insufficient balance");

    try {
      const res = await fetch("/api/invest", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ amount: Number(amount), days }),
      });
      const data = await res.json();
      if (data?.success) {
        alert("Investment created successfully!");
        loadDashboard();
      } else {
        alert(data?.message || "Investment failed.");
      }
    } catch (err) {
      alert("Investment error. Check console.");
    } finally {
      setModals({ ...modals, invest: false });
    }
  };

  const handleBotActivation = async () => {
    const plan = BOT_PLANS[0];
    if (walletBalance < plan.price) return;

    try {
      const res = await fetch("/api/bot/activate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ plan: plan.id, amount: plan.price }),
      });
      const data = await res.json();
      if (data?.success) {
        alert("Bot activated successfully!");
        loadDashboard();
      } else {
        alert(data?.message || "Bot activation failed.");
      }
    } catch (err) {
      alert("Bot activation error. Check console.");
    } finally {
      setModals({ ...modals, bot: false });
    }
  };

  // ===== INITIAL LOAD =====
  useEffect(() => {
    if (!token) {
      window.location.href = "/login";
    } else {
      loadDashboard();
    }
  }, [token, loadDashboard]);

  // ===== BACKGROUND HISTORY LOAD =====
  useEffect(() => {
    if (!token) return;

    // Dashboard first, history shortly after
    const timer = setTimeout(() => {
      loadHistory();
    }, 300);

    return () => clearTimeout(timer);
  }, [token, loadHistory]);

  // ===== RENDER =====
  if (isLoading) {
    return (
      <div style={styles.loading}>
        <div style={styles.loadingSpinner} />
        <p>Loading dashboard data...</p>
      </div>
    );
  }

  const referralLink = `${window.location.origin}/register?ref=${userId}`;

  const getChainSignals = (chain) => signals.filter((s) => s.chain === chain).slice(0, 10);

  const activeInvestments = Array.isArray(investments)
    ? investments.filter((x) => x && x.isActive !== false)
    : [];

  const primaryInvestment =
    activeInvestments[0] ||
    (Array.isArray(investments) && investments.length ? investments[0] : null);

  const investmentStart = primaryInvestment?.startTime
    ? new Date(primaryInvestment.startTime)
    : null;

  const investmentEnd = primaryInvestment?.endTime
    ? new Date(primaryInvestment.endTime)
    : null;

  const investmentDays = Number(primaryInvestment?.planDays || 0);

  const remainingInvestmentDays = investmentEnd
    ? Math.max(
        0,
        Math.ceil(
          (investmentEnd.getTime() - Date.now()) /
            (1000 * 60 * 60 * 24)
        )
      )
    : 0;

  const investmentProgress =
    investmentDays > 0
      ? Math.min(
          100,
          Math.max(
            0,
            ((investmentDays - remainingInvestmentDays) /
              investmentDays) *
              100
          )
        )
      : 0;

  const recentTransactions = [
    ...(history?.deposits || []).map((x) => ({
      type: "Deposit",
      amount: Number(x.amount || 0),
      positive: true,
      status: x.status || "Success",
      date: x.createdAt,
      icon: "↓",
      cls: "deposit",
    })),
    ...(history?.withdrawals || []).map((x) => ({
      type: "Withdrawal",
      amount: Number(x.amount || 0),
      positive: false,
      status: x.status || "Pending",
      date: x.createdAt,
      icon: "↑",
      cls: "withdraw",
    })),
    ...(history?.transfers || []).map((x) => ({
      type: "Wallet Transfer",
      amount: Number(x.amount || 0),
      positive: false,
      status: x.status || "Success",
      date: x.createdAt,
      icon: "⇄",
      cls: "transfer",
    })),
    ...(history?.investments || []).map((x) => ({
      type: "Investment",
      amount: Number(x.amount || 0),
      positive: false,
      status: x.isActive === false ? "Completed" : "Active",
      date: x.startTime || x.createdAt,
      icon: "↗",
      cls: "investment",
    })),
  ]
    .sort(
      (a, b) =>
        new Date(b.date || 0).getTime() -
        new Date(a.date || 0).getTime()
    )
    .slice(0, 5);

  const marketItems = [
    { symbol: "BTC/USDT", name: "Bitcoin", pair: "BINANCE:BTCUSDT", icon: "₿" },
    { symbol: "ETH/USDT", name: "Ethereum", pair: "BINANCE:ETHUSDT", icon: "Ξ" },
    { symbol: "BNB/USDT", name: "BNB", pair: "BINANCE:BNBUSDT", icon: "◆" },
    { symbol: "SOL/USDT", name: "Solana", pair: "BINANCE:SOLUSDT", icon: "S" },
  ];

  return (
    <>

<MobileMenu
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        onNavigate={(action) => {
          if (action === "menu") {
            setMobileMenuOpen(true);
            return;
          }

          if (action === "transactions") {
            setHistoryFilter("all");
            setHistoryModalOpen(true);
            loadHistory();
            return;
          }

          if (action === "team") {
            setModals((prev) => ({
              ...prev,
              team: true,
            }));
            return;
          }

          if (action === "bot" && !userBotStatus?.active) {
            setModals((prev) => ({
              ...prev,
              bot: true,
            }));
          }
        }}
        onLogout={() => {
          localStorage.clear();
          window.location.href = "/login";
        }}
      />

      <style>{`
        .ax-app {
          min-height:100vh;
          background:
            radial-gradient(circle at 30% 0%, rgba(34,197,94,.055), transparent 25%),
            radial-gradient(circle at 85% 15%, rgba(59,130,246,.045), transparent 25%),
            #020609;
          color:#dbeafe;
          font-family:Inter,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
        }

        .ax-layout {
          display:flex;
          min-height:100vh;
        }

        .ax-sidebar {
          width:238px;
          flex:0 0 238px;
          position:fixed;
          left:0;
          top:0;
          bottom:0;
          z-index:10000;
          overflow-y:auto;
          background:
            linear-gradient(180deg,#02070b 0%,#030a0f 100%);
          border-right:1px solid #17232d;
          padding:18px 12px;
        }

        .ax-logo {
          height:58px;
          display:flex;
          align-items:center;
          gap:10px;
          padding:0 8px 16px;
          margin-bottom:8px;
          border-bottom:1px solid #17232d;
        }

        .ax-logo-mark {
          width:42px;
          height:42px;
          display:flex;
          align-items:center;
          justify-content:center;
          color:#39ff14;
          font-size:30px;
          font-weight:900;
        }

        .ax-logo-title {
          color:#f8fafc;
          font-size:18px;
          line-height:18px;
          font-weight:900;
        }

        .ax-logo-sub {
          color:#39ff14;
          font-size:7px;
          letter-spacing:1px;
          margin-top:3px;
        }

        .ax-nav-section {
          color:#65ff21;
          font-size:10px;
          font-weight:900;
          letter-spacing:.8px;
          padding:12px 8px 5px;
        }

        .ax-nav-btn {
          width:100%;
          display:flex;
          align-items:center;
          gap:10px;
          padding:8px 10px;
          margin:2px 0;
          border:0;
          border-radius:7px;
          background:transparent;
          color:#cbd5e1;
          text-align:left;
          font-size:12px;
          cursor:pointer;
        }

        .ax-nav-btn:hover {
          background:#0d1a21;
          color:#fff;
        }

        .ax-nav-btn.active {
          background:linear-gradient(90deg,#159400,#0c6000);
          color:#fff;
          box-shadow:0 0 15px rgba(34,197,94,.16);
        }

        .ax-nav-icon {
          width:18px;
          text-align:center;
          color:#b6ff00;
          font-weight:900;
        }

        .ax-main {
          width:calc(100% - 238px);
          margin-left:238px;
          min-width:0;
        }

        .ax-topbar {
          height:70px;
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:20px;
          padding:0 24px;
          border-bottom:1px solid #17232d;
          background:rgba(2,7,11,.92);
          position:sticky;
          top:0;
          z-index:9000;
          backdrop-filter:blur(15px);
        }

        .ax-top-title {
          color:#f8fafc;
          font-size:20px;
          font-weight:800;
          margin:0;
        }

        .ax-top-welcome {
          color:#64748b;
          font-size:11px;
          margin-top:3px;
        }

        .ax-top-right {
          display:flex;
          align-items:center;
          gap:22px;
        }

        .ax-server {
          color:#94a3b8;
          font-size:10px;
        }

        .ax-server strong {
          color:#cbd5e1;
          display:block;
          margin-top:2px;
        }

        .ax-account {
          display:flex;
          align-items:center;
          gap:9px;
          padding-left:18px;
          border-left:1px solid #1e293b;
        }

        .ax-avatar {
          width:34px;
          height:34px;
          border:1px solid #39ff14;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          background:#08150b;
          color:#65ff21;
          font-size:17px;
        }

        .ax-account-name {
          color:#f8fafc;
          font-size:11px;
          font-weight:800;
        }

        .ax-account-id {
          color:#64748b;
          font-size:9px;
          margin-top:2px;
        }

        .ax-content {
          padding:18px;
          max-width:1700px;
          margin:0 auto;
        }

        .ax-status-alert {
          margin-bottom:14px;
          padding:10px 14px;
          border:1px solid rgba(239,68,68,.35);
          border-radius:8px;
          background:rgba(127,29,29,.25);
          color:#fca5a5;
          font-size:11px;
        }

        .ax-stat-grid {
          display:grid;
          grid-template-columns:repeat(5,minmax(0,1fr));
          gap:10px;
          margin-bottom:12px;
        }

        .ax-stat {
          min-height:96px;
          padding:15px;
          display:flex;
          align-items:center;
          gap:12px;
          border:1px solid #172b20;
          border-radius:10px;
          background:linear-gradient(145deg,#06100d,#061018);
          box-shadow:0 8px 25px rgba(0,0,0,.22);
        }

        .ax-stat.blue {
          border-color:#12375a;
        }

        .ax-stat.purple {
          border-color:#39155e;
        }

        .ax-stat.gold {
          border-color:#513812;
        }

        .ax-stat-icon {
          width:42px;
          height:42px;
          flex:0 0 42px;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius:11px;
          background:rgba(34,197,94,.14);
          color:#65ff21;
          font-size:20px;
        }

        .ax-stat.blue .ax-stat-icon {
          background:rgba(59,130,246,.18);
          color:#60a5fa;
        }

        .ax-stat.purple .ax-stat-icon {
          background:rgba(168,85,247,.18);
          color:#c084fc;
        }

        .ax-stat.gold .ax-stat-icon {
          background:rgba(245,158,11,.18);
          color:#fbbf24;
        }

        .ax-stat-label {
          display:block;
          color:#84cc16;
          font-size:9px;
          font-weight:900;
          letter-spacing:.5px;
          margin-bottom:5px;
        }

        .ax-stat.blue .ax-stat-label { color:#60a5fa; }
        .ax-stat.purple .ax-stat-label { color:#c084fc; }
        .ax-stat.gold .ax-stat-label { color:#fbbf24; }

        .ax-stat-value {
          color:#f8fafc;
          font-size:19px;
          font-weight:900;
          display:block;
        }

        .ax-stat-small {
          color:#64748b;
          font-size:9px;
          margin-top:3px;
          display:block;
        }

        .ax-actions {
          display:grid;
          grid-template-columns:repeat(5,minmax(0,1fr));
          gap:10px;
          margin-bottom:14px;
        }

        .ax-action {
          min-height:53px;
          border:1px solid rgba(255,255,255,.08);
          border-radius:8px;
          color:#fff;
          font-weight:800;
          cursor:pointer;
          font-size:13px;
          transition:.2s;
        }

        .ax-action:hover {
          transform:translateY(-2px);
          filter:brightness(1.12);
        }

        .ax-action.deposit {
          background:linear-gradient(135deg,#15803d,#22c55e);
        }

        .ax-action.withdraw {
          background:linear-gradient(135deg,#991b1b,#dc2626);
        }

        .ax-action.transfer {
          background:linear-gradient(135deg,#075985,#2563eb);
        }

        .ax-action.invest {
          background:linear-gradient(135deg,#581c87,#9333ea);
        }

        .ax-action.bot {
          background:linear-gradient(135deg,#075e59,#0891b2);
        }

        .ax-main-grid {
          display:grid;
          grid-template-columns:1.25fr 1fr .98fr;
          gap:10px;
          align-items:stretch;
        }

        .ax-panel {
          border:1px solid #172b32;
          border-radius:10px;
          background:linear-gradient(145deg,#040c11,#061015);
          padding:15px;
          min-width:0;
          box-shadow:0 8px 25px rgba(0,0,0,.2);
        }

        .ax-panel-title {
          display:flex;
          align-items:center;
          justify-content:space-between;
          border-bottom:1px solid #17232d;
          padding-bottom:10px;
          margin-bottom:12px;
        }

        .ax-panel-title h3 {
          color:#f8fafc;
          font-size:16px;
          margin:0;
          font-weight:800;
        }

        .ax-view {
          padding:5px 10px;
          border:1px solid #237a0e;
          border-radius:6px;
          background:#061407;
          color:#6dff21;
          font-size:9px;
          font-weight:800;
          cursor:pointer;
        }

        .ax-invest-card {
          border:1px solid #17362c;
          border-radius:8px;
          padding:14px;
          background:rgba(2,15,11,.55);
        }

        .ax-invest-head {
          display:flex;
          align-items:center;
          gap:12px;
        }

        .ax-invest-icon {
          width:55px;
          height:55px;
          flex:0 0 55px;
          display:flex;
          align-items:center;
          justify-content:center;
          border:1px solid #21d76b;
          border-radius:15px;
          color:#65ff21;
          background:#071a12;
          font-size:24px;
          box-shadow:0 0 20px rgba(34,197,94,.12);
        }

        .ax-invest-name {
          color:#f8fafc;
          font-size:15px;
          font-weight:800;
        }

        .ax-active-badge {
          display:inline-block;
          margin-left:8px;
          padding:4px 7px;
          border-radius:5px;
          background:#08752a;
          color:#d1fae5;
          font-size:8px;
          font-weight:900;
        }

        .ax-invest-stats {
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:7px;
          margin-top:15px;
        }

        .ax-mini-stat {
          padding:9px;
          border:1px solid #16252d;
          border-radius:7px;
          background:#050c11;
        }

        .ax-mini-stat span {
          display:block;
          color:#64748b;
          font-size:8px;
          margin-bottom:5px;
        }

        .ax-mini-stat strong {
          color:#f8fafc;
          font-size:12px;
        }

        .ax-contract {
          display:grid;
          grid-template-columns:repeat(4,1fr);
          gap:7px;
          margin-top:12px;
        }

        .ax-contract-box {
          padding:10px;
          border:1px solid #182933;
          border-radius:7px;
          background:#050b10;
        }

        .ax-contract-box span {
          display:block;
          color:#64748b;
          font-size:8px;
          margin-bottom:4px;
        }

        .ax-contract-box strong {
          color:#cbd5e1;
          font-size:11px;
        }

        .ax-contract-box.remaining {
          border-color:#164e2c;
          background:#06160c;
        }

        .ax-contract-box.remaining strong {
          color:#39ff14;
          font-size:15px;
        }

        .ax-progress {
          height:7px;
          margin-top:12px;
          overflow:hidden;
          border-radius:99px;
          background:#17212a;
        }

        .ax-progress > div {
          height:100%;
          border-radius:99px;
          background:linear-gradient(90deg,#16a34a,#65ff21);
          box-shadow:0 0 10px rgba(101,255,33,.35);
        }

        .ax-progress-text {
          display:flex;
          justify-content:space-between;
          margin-top:5px;
          color:#64748b;
          font-size:8px;
        }

        .ax-bot-wrap {
          display:flex;
          gap:15px;
          align-items:center;
          min-height:210px;
        }

        .ax-bot-orb {
          width:115px;
          height:115px;
          flex:0 0 115px;
          display:flex;
          align-items:center;
          justify-content:center;
          border:1px solid #39ff14;
          border-radius:50%;
          background:
            radial-gradient(circle,#102a12 0%,#061009 55%,#020609 100%);
          box-shadow:
            0 0 20px rgba(34,197,94,.15),
            inset 0 0 30px rgba(34,197,94,.12);
          font-size:55px;
        }

        .ax-bot-label {
          color:#64748b;
          font-size:9px;
        }

        .ax-bot-status {
          color:#39ff14;
          font-size:22px;
          font-weight:900;
          margin:3px 0 12px;
        }

        .ax-bot-status::after {
          content:"";
          display:inline-block;
          width:8px;
          height:8px;
          margin-left:6px;
          border-radius:50%;
          background:#39ff14;
          box-shadow:0 0 10px #39ff14;
        }

        .ax-bot-row {
          display:flex;
          justify-content:space-between;
          gap:10px;
          padding:6px 0;
          border-top:1px solid #17232d;
          color:#64748b;
          font-size:9px;
        }

        .ax-bot-row strong {
          color:#cbd5e1;
        }

        .ax-bot-go {
          width:100%;
          margin-top:10px;
          padding:10px;
          border:0;
          border-radius:7px;
          background:linear-gradient(90deg,#0b7d18,#20a900);
          color:#fff;
          font-weight:900;
          font-size:10px;
          cursor:pointer;
        }

        .ax-market-tabs {
          display:flex;
          gap:2px;
          overflow:auto;
          border-bottom:1px solid #17232d;
          margin-bottom:12px;
        }

        .ax-market-tab {
          padding:7px 9px;
          border:0;
          border-bottom:2px solid transparent;
          background:transparent;
          color:#64748b;
          white-space:nowrap;
          font-size:9px;
          cursor:pointer;
        }

        .ax-market-tab.active {
          color:#39ff14;
          border-bottom-color:#39ff14;
        }

        .ax-market-main {
          display:flex;
          justify-content:space-between;
          align-items:center;
          padding:8px 0;
        }

        .ax-coin {
          display:flex;
          align-items:center;
          gap:8px;
        }

        .ax-coin-icon {
          width:35px;
          height:35px;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius:50%;
          background:#f7931a;
          color:#fff;
          font-weight:900;
        }

        .ax-coin-name {
          color:#f8fafc;
          font-size:12px;
          font-weight:800;
        }

        .ax-coin-sub {
          color:#64748b;
          font-size:8px;
          margin-top:2px;
        }

        .ax-market-price {
          text-align:right;
          color:#f8fafc;
          font-size:16px;
          font-weight:900;
        }

        .ax-market-change {
          color:#39ff14;
          font-size:11px;
          margin-top:3px;
        }

        .ax-market-placeholder {
          height:145px;
          display:flex;
          align-items:center;
          justify-content:center;
          border:1px solid #17232d;
          border-radius:7px;
          background:
            linear-gradient(rgba(255,255,255,.025) 1px,transparent 1px),
            linear-gradient(90deg,rgba(255,255,255,.025) 1px,transparent 1px);
          background-size:25px 25px;
          color:#334155;
          font-size:11px;
        }

        .ax-bottom-grid {
          display:grid;
          grid-template-columns:1.25fr 1fr .98fr;
          gap:10px;
          margin-top:10px;
        }

        .ax-roi-panel {
          min-height:280px;
        }

        .ax-roi-controls {
          display:flex;
          gap:5px;
        }

        .ax-roi-btn {
          padding:5px 9px;
          border:0;
          border-radius:5px;
          background:#14202a;
          color:#94a3b8;
          font-size:8px;
          cursor:pointer;
        }

        .ax-roi-btn.active {
          background:#16820e;
          color:#fff;
        }

        .ax-team-grid {
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:8px;
        }

        .ax-team-card {
          padding:13px;
          border:1px solid #172a31;
          border-radius:8px;
          background:#050d12;
        }

        .ax-team-card-top {
          display:flex;
          align-items:center;
          gap:8px;
        }

        .ax-team-icon {
          width:31px;
          height:31px;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius:9px;
          background:#092314;
          color:#65ff21;
        }

        .ax-team-label {
          color:#64748b;
          font-size:8px;
        }

        .ax-team-value {
          color:#f8fafc;
          font-size:15px;
          font-weight:900;
          margin-top:3px;
        }

        .ax-team-growth {
          color:#39ff14;
          font-size:8px;
          margin-top:4px;
        }

        .ax-transactions {
          display:flex;
          flex-direction:column;
        }

        .ax-tx {
          display:grid;
          grid-template-columns:34px 1fr auto;
          gap:8px;
          align-items:center;
          padding:9px 0;
          border-bottom:1px solid #142029;
        }

        .ax-tx-icon {
          width:29px;
          height:29px;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius:50%;
          font-weight:900;
          color:#fff;
          background:#0f5132;
        }

        .ax-tx-icon.withdraw { background:#7f1d1d; }
        .ax-tx-icon.transfer { background:#1e3a8a; }
        .ax-tx-icon.investment { background:#581c87; }

        .ax-tx-name {
          color:#e2e8f0;
          font-size:10px;
          font-weight:800;
        }

        .ax-tx-sub {
          color:#64748b;
          font-size:8px;
          margin-top:2px;
        }

        .ax-tx-right {
          text-align:right;
        }

        .ax-tx-amount {
          font-size:10px;
          font-weight:900;
        }

        .ax-tx-amount.plus { color:#39ff14; }
        .ax-tx-amount.minus { color:#ef4444; }

        .ax-tx-status {
          color:#39ff14;
          font-size:8px;
          margin-top:2px;
        }

        .ax-tx-status.pending {
          color:#fbbf24;
        }

        .ax-ai-banner {
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:20px;
          margin-top:10px;
          padding:18px 22px;
          min-height:80px;
          border:1px solid #174b1d;
          border-radius:10px;
          overflow:hidden;
          background:
            radial-gradient(circle at 10% 50%,rgba(34,197,94,.18),transparent 25%),
            linear-gradient(90deg,#06120a,#08180d,#06100c);
        }

        .ax-ai-eyebrow {
          color:#39ff14;
          font-size:10px;
          font-weight:900;
          letter-spacing:1px;
        }

        .ax-ai-banner h3 {
          margin:3px 0;
          color:#f8fafc;
          font-size:21px;
          font-weight:900;
        }

        .ax-ai-banner p {
          margin:0;
          color:#64748b;
          font-size:9px;
        }

        .ax-ai-btn {
          padding:12px 24px;
          border:0;
          border-radius:8px;
          background:#16820e;
          color:#fff;
          font-size:10px;
          font-weight:900;
          cursor:pointer;
          white-space:nowrap;
        }

        .ax-footer {
          display:flex;
          justify-content:space-between;
          align-items:center;
          gap:15px;
          margin-top:10px;
          padding:12px 5px;
          color:#475569;
          font-size:8px;
        }

        @media(max-width:1250px) {
          .ax-stat-grid {
            grid-template-columns:repeat(3,1fr);
          }

          .ax-actions {
            grid-template-columns:repeat(3,1fr);
          }

          .ax-main-grid,
          .ax-bottom-grid {
            grid-template-columns:1fr 1fr;
          }

          .ax-main-grid > :last-child {
            grid-column:1 / -1;
          }
        }

        @media(max-width:850px) {
          .ax-sidebar {
            width:68px;
            flex-basis:68px;
            padding:12px 7px;
          }

          .ax-logo {
            justify-content:center;
            padding-left:0;
            padding-right:0;
          }

          .ax-logo-text,
          .ax-nav-section,
          .ax-nav-btn span:not(.ax-nav-icon),
          .ax-logo-sub {
            display:none;
          }

          .ax-nav-btn {
            justify-content:center;
          }

          .ax-main {
            width:calc(100% - 68px);
            margin-left:68px;
          }

          .ax-stat-grid {
            grid-template-columns:1fr 1fr;
          }

          .ax-actions {
            grid-template-columns:1fr 1fr;
          }

          .ax-main-grid,
          .ax-bottom-grid {
            grid-template-columns:1fr;
          }

          .ax-main-grid > :last-child {
            grid-column:auto;
          }

          .ax-top-right .ax-server {
            display:none;
          }
        }

        @media(max-width:560px) {
          .ax-sidebar {
            display:none;
          }

          .ax-main {
            width:100%;
            margin-left:0;
          }

          .ax-topbar {
            padding:0 12px;
          }

          .ax-content {
            padding:10px;
          }

          .ax-stat-grid,
          .ax-actions {
            grid-template-columns:1fr;
          }

          .ax-contract {
            grid-template-columns:1fr 1fr;
          }

          .ax-invest-stats {
            grid-template-columns:1fr;
          }

          .ax-bot-wrap {
            flex-direction:column;
            align-items:flex-start;
          }

          .ax-ai-banner {
            align-items:flex-start;
            flex-direction:column;
          }

          .ax-footer {
            flex-direction:column;
            align-items:flex-start;
          }
        }
      `}</style>

      <TradingViewTicker position="top" />

      <div className="ax-app">
        <div className="ax-layout">

          {/* ================= SIDEBAR ================= */}
          <aside className="ax-sidebar">

            <div className="ax-logo">
              <div className="ax-logo-mark">▲</div>
              <div className="ax-logo-text">
                <div className="ax-logo-title">ALGOXPO</div>
                <div className="ax-logo-sub">AI POWERED TRADING</div>
              </div>
            </div>

            <div className="ax-nav-section">MAIN</div>

            <button className="ax-nav-btn active">
              <span className="ax-nav-icon">▣</span>
              <span>Dashboard</span>
            </button>

            <div className="ax-nav-section">WALLET</div>

            <button className="ax-nav-btn" onClick={handleDeposit}>
              <span className="ax-nav-icon">↓</span>
              <span>Deposit</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setHistoryFilter("deposit");
                setHistoryModalOpen(true);
                loadHistory();
              }}
            >
              <span className="ax-nav-icon">◉</span>
              <span>Deposit History</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setWithdrawSuccess(false);
                setModals({ ...modals, withdraw: true });
              }}
            >
              <span className="ax-nav-icon">↑</span>
              <span>Withdraw</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setHistoryFilter("withdrawal");
                setHistoryModalOpen(true);
                loadHistory();
              }}
            >
              <span className="ax-nav-icon">◉</span>
              <span>Withdrawal History</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => setModals({ ...modals, transfer: true })}
            >
              <span className="ax-nav-icon">⇄</span>
              <span>Wallet Transfer</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setHistoryFilter("transfer");
                setHistoryModalOpen(true);
                loadHistory();
              }}
            >
              <span className="ax-nav-icon">⇄</span>
              <span>Transfer History</span>
            </button>

            <div className="ax-nav-section">INVESTMENTS</div>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setHistoryFilter("investment");
                setHistoryModalOpen(true);
                loadHistory();
              }}
            >
              <span className="ax-nav-icon">◈</span>
              <span>Active Investments</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setHistoryFilter("investment");
                setHistoryModalOpen(true);
                loadHistory();
              }}
            >
              <span className="ax-nav-icon">▣</span>
              <span>Investment History</span>
            </button>

            <div className="ax-nav-section">AI TRADING BOT</div>

            <button
              className="ax-nav-btn"
              onClick={() => {
                if (!userBotStatus?.active) {
                  setModals({ ...modals, bot: true });
                }
              }}
            >
              <span className="ax-nav-icon">🤖</span>
              <span>Bot Dashboard</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                if (!userBotStatus?.active) {
                  setModals({ ...modals, bot: true });
                }
              }}
            >
              <span className="ax-nav-icon">⚡</span>
              <span>Activate Bot</span>
            </button>

            <div className="ax-nav-section">TEAM</div>

            <button
              className="ax-nav-btn"
              onClick={() => setModals({ ...modals, team: true })}
            >
              <span className="ax-nav-icon">♣</span>
              <span>My Team</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => setModals({ ...modals, team: true })}
            >
              <span className="ax-nav-icon">♣</span>
              <span>Direct Members</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => setModals({ ...modals, team: true })}
            >
              <span className="ax-nav-icon">♣</span>
              <span>Team Members</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => setModals({ ...modals, team: true })}
            >
              <span className="ax-nav-icon">★</span>
              <span>Level & Business</span>
            </button>

            <div className="ax-nav-section">INCOME</div>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setHistoryFilter("all");
                setHistoryModalOpen(true);
                loadHistory();
              }}
            >
              <span className="ax-nav-icon">$</span>
              <span>Direct Income</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setHistoryFilter("all");
                setHistoryModalOpen(true);
                loadHistory();
              }}
            >
              <span className="ax-nav-icon">$</span>
              <span>Team Income</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                setHistoryFilter("all");
                setHistoryModalOpen(true);
                loadHistory();
              }}
            >
              <span className="ax-nav-icon">▤</span>
              <span>Income History</span>
            </button>

            <div className="ax-nav-section">ROI & PERFORMANCE</div>

            <button
              className="ax-nav-btn"
              onClick={() =>
                document
                  .getElementById("ax-roi")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              <span className="ax-nav-icon">⌁</span>
              <span>ROI Report</span>
            </button>

            <div className="ax-nav-section">LIVE MARKET</div>

            <button
              className="ax-nav-btn"
              onClick={() => {
                window.location.href = "/btc-trading";
              }}
            >
              <span className="ax-nav-icon">₿</span>
              <span>BTC Trading</span>
            </button>
            <button
              className="ax-nav-btn"
              onClick={() => {
                window.location.href = "/gold-trading";
              }}
            >
              <span className="ax-nav-icon">🥇</span>
              <span>Gold Trading</span>
            </button>


            <button
              className="ax-nav-btn"
              onClick={() =>
                document
                  .getElementById("ax-market")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              <span className="ax-nav-icon">▥</span>
              <span>Live Market</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() =>
                window.open(
                  "https://www.tradingview.com/",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              <span className="ax-nav-icon">⌁</span>
              <span>TradingView</span>
            </button>

            <div className="ax-nav-section">PROFILE</div>

            <button
              className="ax-nav-btn"
              onClick={() => {
                alert("Profile settings are available from your account menu.");
              }}
            >
              <span className="ax-nav-icon">⚙</span>
              <span>Profile Settings</span>
            </button>

            <button
              className="ax-nav-btn"
              onClick={() => {
                alert("Security settings can be managed from your account.");
              }}
            >
              <span className="ax-nav-icon">●</span>
              <span>Security Settings</span>
            </button>

            <button
              className="ax-nav-btn"
              style={{ marginTop: 15 }}
              onClick={() => {
                localStorage.clear();
                window.location.href = "/login";
              }}
            >
              <span className="ax-nav-icon">↪</span>
              <span>Logout</span>
            </button>

          </aside>

          {/* ================= MAIN ================= */}
          <main className="ax-main">

            <header className="ax-topbar">
              <div>
                <h1 className="ax-top-title">Dashboard</h1>
                <div className="ax-top-welcome">
                  Welcome back, {userId} 👋
                </div>
              </div>

              <div className="ax-top-right">
                <div className="ax-server">
                  ● Server Time
                  <strong>
                    {new Date().toLocaleString()}
                  </strong>
                </div>

                <div className="ax-account">
                  <div className="ax-avatar">●</div>
                  <div>
                    <div className="ax-account-name">
                      {userId}
                    </div>
                    <div className="ax-account-id">
                      ID: {userId}
                    </div>
                  </div>
                </div>
              </div>
            </header>

            <div className="ax-content">

              {!socketConnected && (
                <div className="ax-status-alert">
                  ⚠️ Live updates disconnected. Refresh page.
                </div>
              )}

              {/* ================= BALANCES ================= */}
              <div className="ax-stat-grid">

                <div className="ax-stat">
                  <div className="ax-stat-icon">▣</div>
                  <div>
                    <span className="ax-stat-label">
                      WALLET BALANCE
                    </span>
                    <strong className="ax-stat-value">
                      ${walletBalance.toFixed(2)}
                    </strong>
                    <small className="ax-stat-small">
                      Available USDT
                    </small>
                  </div>
                </div>

                <div className="ax-stat blue">
                  <div className="ax-stat-icon">$</div>
                  <div>
                    <span className="ax-stat-label">
                      EARNING BALANCE
                    </span>
                    <strong className="ax-stat-value">
                      ${earningBalance.toFixed(2)}
                    </strong>
                    <small className="ax-stat-small">
                      Total earnings available
                    </small>
                  </div>
                </div>

                <div className="ax-stat">
                  <div className="ax-stat-icon">♣</div>
                  <div>
                    <span className="ax-stat-label">
                      DIRECT INCOME
                    </span>
                    <strong className="ax-stat-value">
                      ${directIncome.toFixed(2)}
                    </strong>
                    <small className="ax-stat-small">
                      Total earned
                    </small>
                  </div>
                </div>

                <div className="ax-stat purple">
                  <div className="ax-stat-icon">♣</div>
                  <div>
                    <span className="ax-stat-label">
                      TEAM INCOME
                    </span>
                    <strong className="ax-stat-value">
                      ${teamIncome.toFixed(2)}
                    </strong>
                    <small className="ax-stat-small">
                      Total team earnings
                    </small>
                  </div>
                </div>

                <div className="ax-stat gold">
                  <div className="ax-stat-icon">⌁</div>
                  <div>
                    <span className="ax-stat-label">
                      TOTAL ROI EARNING
                    </span>
                    <strong className="ax-stat-value">
                      ${Number(roiTotal || 0).toFixed(2)}
                    </strong>
                    <small className="ax-stat-small">
                      Total ROI earned
                    </small>
                  </div>
                </div>

              </div>

              {/* ================= TODAY / YESTERDAY INCOME ================= */}
              <div
                className="ax-stats"
                style={{
                  marginTop: 14,
                  marginBottom: 18,
                }}
              >

                <div className="ax-stat green">
                  <div className="ax-stat-icon">📈</div>
                  <div>
                    <span className="ax-stat-label">
                      TODAY INCOME
                    </span>
                    <strong className="ax-stat-value">
                      ${Number(earnings.today || 0).toFixed(2)}
                    </strong>
                    <small className="ax-stat-small">
                      Today's earnings
                    </small>
                  </div>
                </div>

                <div className="ax-stat blue">
                  <div className="ax-stat-icon">📊</div>
                  <div>
                    <span className="ax-stat-label">
                      YESTERDAY INCOME
                    </span>
                    <strong className="ax-stat-value">
                      ${Number(earnings.yesterday || 0).toFixed(2)}
                    </strong>
                    <small className="ax-stat-small">
                      Yesterday's earnings
                    </small>
                  </div>
                </div>

              </div>

              {/* ================= ACTIONS ================= */}
              <div className="ax-actions">

                <button
                  className="ax-action deposit"
                  onClick={handleDeposit}
                >
                  ↓ &nbsp; Deposit
                </button>

                <button
                  className="ax-action withdraw"
                  onClick={() => {
                    setWithdrawSuccess(false);
                    setModals({ ...modals, withdraw: true });
                  }}
                >
                  ↑ &nbsp; Withdraw
                </button>

                <button
                  className="ax-action transfer"
                  onClick={() =>
                    setModals({ ...modals, transfer: true })
                  }
                >
                  ⇄ &nbsp; Wallet Transfer
                </button>

                <button
                  className="ax-action invest"
                  onClick={() =>
                    setModals({ ...modals, invest: true })
                  }
                >
                  ↗ &nbsp; Invest Now
                </button>

                <button
                  className="ax-action bot"
                  disabled={userBotStatus?.active}
                  onClick={() => {
                    if (!userBotStatus?.active) {
                      setModals({ ...modals, bot: true });
                    }
                  }}
                >
                  🤖 &nbsp;
                  {userBotStatus?.active
                    ? "AI Bot Active"
                    : "Activate AI Bot"}
                </button>

              </div>

              {/* ================= MAIN THREE COLUMNS ================= */}
              <div className="ax-main-grid">

                {/* ACTIVE INVESTMENT */}
                <section className="ax-panel">

                  <div className="ax-panel-title">
                    <h3>ACTIVE INVESTMENT</h3>

                    <button
                      className="ax-view"
                      onClick={() => {
                        setHistoryFilter("investment");
                        setHistoryModalOpen(true);
                        loadHistory();
                      }}
                    >
                      View All
                    </button>
                  </div>

                  {/* ================= INVESTMENT SUMMARY ================= */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3,minmax(0,1fr))",
                      gap: 10,
                      marginBottom: 14,
                    }}
                  >

                    <div className="ax-mini-stat">
                      <span>TOTAL INVESTMENTS</span>
                      <strong>
                        {Array.isArray(investments)
                          ? investments.length
                          : 0}
                      </strong>
                    </div>

                    <div className="ax-mini-stat">
                      <span>TOTAL CONTRACT VALUE</span>
                      <strong>
                        $
                        {(
                          Array.isArray(investments)
                            ? investments.reduce(
                                (sum, item) =>
                                  sum +
                                  Number(item?.amount || 0),
                                0
                              )
                            : 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                    <div className="ax-mini-stat">
                      <span>TOTAL ROI EARNED</span>
                      <strong>
                        $
                        {(
                          Array.isArray(investments)
                            ? investments.reduce(
                                (sum, item) =>
                                  sum +
                                  Number(
                                    item?.totalProfitGenerated || 0
                                  ),
                                0
                              )
                            : 0
                        ).toFixed(2)}
                      </strong>
                    </div>

                  </div>

                  {Array.isArray(investments) && investments.length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        maxHeight: 520,
                        overflowY: "auto",
                        paddingRight: 3,
                      }}
                    >

                      {investments.map((investment, index) => {

                        const startDate = investment?.startTime
                          ? new Date(investment.startTime)
                          : null;

                        const endDate = investment?.endTime
                          ? new Date(investment.endTime)
                          : null;

                        const planDays = Number(
                          investment?.planDays || 0
                        );

                        const amount = Number(
                          investment?.amount || 0
                        );

                        const totalProfit = Number(
                          investment?.totalProfitGenerated || 0
                        );

                        const remainingDays = endDate
                          ? Math.max(
                              0,
                              Math.ceil(
                                (endDate.getTime() - Date.now()) /
                                  (1000 * 60 * 60 * 24)
                              )
                            )
                          : 0;

                        const completed =
                          investment?.isActive === false ||
                          (endDate && endDate.getTime() <= Date.now());

                        const progress = planDays > 0
                          ? Math.min(
                              100,
                              Math.max(
                                0,
                                ((planDays - remainingDays) /
                                  planDays) *
                                  100
                              )
                            )
                          : 0;

                        return (
                          <div
                            key={
                              investment?._id ||
                              investment?.id ||
                              index
                            }
                            className="ax-invest-card"
                          >

                            <div className="ax-invest-head">

                              <div className="ax-invest-icon">
                                ◈
                              </div>

                              <div style={{ flex: 1 }}>

                                <div className="ax-invest-name">
                                  AI Power Plan

                                  <span
                                    className="ax-active-badge"
                                    style={{
                                      background: completed
                                        ? "#3f1720"
                                        : undefined,
                                      color: completed
                                        ? "#fb7185"
                                        : undefined,
                                    }}
                                  >
                                    {completed
                                      ? "Completed"
                                      : "Active"}
                                  </span>
                                </div>

                                <div
                                  style={{
                                    color: "#64748b",
                                    fontSize: 9,
                                    marginTop: 4,
                                  }}
                                >
                                  Investment #{index + 1}
                                </div>

                              </div>

                            </div>

                            <div className="ax-invest-stats">

                              <div className="ax-mini-stat">
                                <span>INVESTED AMOUNT</span>
                                <strong>
                                  ${amount.toFixed(2)}
                                </strong>
                              </div>

                              <div className="ax-mini-stat">
                                <span>CONTRACT DAYS</span>
                                <strong>
                                  {planDays} Days
                                </strong>
                              </div>

                              <div className="ax-mini-stat">
                                <span>TOTAL ROI</span>
                                <strong>
                                  ${totalProfit.toFixed(2)}
                                </strong>
                              </div>

                            </div>

                            <div className="ax-progress">
                              <div
                                style={{
                                  width: `${progress}%`,
                                }}
                              />
                            </div>

                            <div className="ax-progress-text">

                              <span>
                                {progress.toFixed(0)}% Complete
                              </span>

                              <span>
                                {completed
                                  ? "Completed"
                                  : `${remainingDays} Days Remaining`}
                              </span>

                            </div>

                            <div className="ax-contract">

                              <div className="ax-contract-box">
                                <span>START DATE</span>
                                <strong>
                                  {startDate
                                    ? startDate.toLocaleDateString()
                                    : "-"}
                                </strong>
                              </div>

                              <div className="ax-contract-box">
                                <span>END DATE</span>
                                <strong>
                                  {endDate
                                    ? endDate.toLocaleDateString()
                                    : "-"}
                                </strong>
                              </div>

                              <div className="ax-contract-box">
                                <span>CONTRACT</span>
                                <strong>
                                  {planDays} Days
                                </strong>
                              </div>

                              <div className="ax-contract-box remaining">
                                <span>REMAINING</span>
                                <strong>
                                  {completed
                                    ? "0 Days"
                                    : `${remainingDays} Days`}
                                </strong>
                              </div>

                            </div>

                          </div>
                        );
                      })}

                    </div>
                  ) : (
                    <div className="ax-empty">
                      No investment found.
                      <br />

                      <button
                        className="ax-view"
                        style={{ marginTop: 12 }}
                        onClick={() =>
                          setModals({
                            ...modals,
                            invest: true,
                          })
                        }
                      >
                        Create Investment
                      </button>
                    </div>
                  )}

                </section>

                {/* AI BOT */}
                <section className="ax-panel">

                  <div className="ax-panel-title">
                    <h3>AI TRADING BOT</h3>

                    <button
                      className="ax-view"
                      onClick={() => {
                        if (!userBotStatus?.active) {
                          setModals({ ...modals, bot: true });
                        }
                      }}
                    >
                      View Details
                    </button>
                  </div>

                  <div className="ax-bot-wrap">

                    <div className="ax-bot-orb">
                      🤖
                    </div>

                    <div style={{ flex: 1 }}>

                      <div className="ax-bot-label">
                        BOT STATUS
                      </div>

                      <div className="ax-bot-status">
                        {userBotStatus?.active
                          ? "ACTIVE"
                          : "INACTIVE"}
                      </div>

                      <div className="ax-bot-row">
                        <span>Bot Name</span>
                        <strong>AlgoXPO AI Bot</strong>
                      </div>

                      <div className="ax-bot-row">
                        <span>Strategy</span>
                        <strong>MEV Advanced</strong>
                      </div>

                      <div className="ax-bot-row">
                        <span>Status</span>
                        <strong>
                          {userBotStatus?.active
                            ? "Running"
                            : "Ready"}
                        </strong>
                      </div>

                    </div>

                  </div>

                  <button
                    className="ax-bot-go"
                    disabled={userBotStatus?.active}
                    onClick={() => {
                      if (!userBotStatus?.active) {
                        setModals({ ...modals, bot: true });
                      }
                    }}
                  >
                    {userBotStatus?.active
                      ? "AI BOT IS RUNNING"
                      : "ACTIVATE AI BOT"}
                  </button>

                </section>

                {/* BTC AI BOT */}
                <section className="ax-panel">

                  <div className="ax-panel-title">
                    <h3>₿ BTC AI TRADING BOT</h3>

                    <button
                      className="ax-view"
                      onClick={() => {
                        document
                          .getElementById("ax-btc-bot")
                          ?.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                          });
                      }}
                    >
                      View Details
                    </button>
                  </div>

                  <div
                    className="ax-bot-wrap"
                    id="ax-btc-bot"
                  >

                    <div className="ax-bot-orb">
                      ₿
                    </div>

                    <div style={{ flex: 1 }}>

                      <div className="ax-bot-label">
                        BTC BOT STATUS
                      </div>

                      <div className="ax-bot-status">
                        {btcBotStatus?.enabled
                          ? "ACTIVE"
                          : "INACTIVE"}
                      </div>

                      <div className="ax-bot-row">
                        <span>Bot Name</span>
                        <strong>AlgoXPO BTC AI Bot</strong>
                      </div>

                      <div className="ax-bot-row">
                        <span>Symbol</span>
                        <strong>BTCUSDT</strong>
                      </div>

                      <div className="ax-bot-row">
                        <span>Quantity</span>
                        <strong>
                          {Number(
                            btcBotStatus?.quantity ||
                            btcBotStatus?.btcAiBotQuantity ||
                            0.001
                          ).toFixed(3)} BTC
                        </strong>
                      </div>

                      <div className="ax-bot-row">
                        <span>Strategy</span>
                        <strong>Liquidity AI</strong>
                      </div>

                      <div className="ax-bot-row">
                        <span>Status</span>
                        <strong>
                          {btcBotStatus?.enabled
                            ? "Running"
                            : "Ready"}
                        </strong>
                      </div>

                    </div>

                  </div>

                  <button
                    className="ax-bot-go"
                    disabled={btcBotLoading}
                    onClick={
                      btcBotStatus?.enabled
                        ? stopBtcBot
                        : startBtcBot
                    }
                  >
                    {btcBotLoading
                      ? "PROCESSING..."
                      : btcBotStatus?.enabled
                        ? "STOP BTC AI BOT"
                        : "START BTC AI BOT"}
                  </button>

                </section>

                {/* LIVE MARKET */}
                <section
                  className="ax-panel"
                  id="ax-market"
                >

                  <div className="ax-panel-title">
                    <h3>LIVE MARKET</h3>

                    <button
                      className="ax-view"
                      onClick={() =>
                        window.open(
                          "https://www.tradingview.com/",
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      View All
                    </button>
                  </div>

                  <div className="ax-market-tabs">
                    {marketItems.map((item, i) => (
                      <button
                        key={item.symbol}
                        className={`ax-market-tab ${
                          i === 0 ? "active" : ""
                        }`}
                      >
                        {item.symbol}
                      </button>
                    ))}
                  </div>

                  <div className="ax-market-main">

                    <div className="ax-coin">
                      <div className="ax-coin-icon">
                        ₿
                      </div>

                      <div>
                        <div className="ax-coin-name">
                          BTC / USDT
                        </div>
                        <div className="ax-coin-sub">
                          Bitcoin
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="ax-market-price">
                        Live
                      </div>

                      <div className="ax-market-change">
                        TradingView
                      </div>
                    </div>

                  </div>

                  <div className="ax-market-placeholder">
                    LIVE BTC / USDT MARKET
                    <br />
                    TradingView data
                  </div>

                </section>


              {/* ================= MODERN MEV BOT ================= */}
              <section
                className="ax-panel ax-mev-dashboard-panel"
                style={{
                  marginTop: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  position: "relative",
                  background:
                    "linear-gradient(145deg,#071225,#030914)",
                  border: "1px solid rgba(124,58,237,.25)",
                  borderRadius: 15,
                  boxShadow: "0 18px 45px rgba(0,0,0,.25)",
                }}
              >

                <div
                  style={{
                    padding: "20px 22px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 14,
                    flexWrap: "wrap",
                    borderBottom:
                      "1px solid rgba(71,85,105,.18)",
                  }}
                >

                  <div>
                    <div
                      style={{
                        color: "#8b5cf6",
                        fontSize: 10,
                        fontWeight: 900,
                        letterSpacing: 1.5,
                      }}
                    >
                      ALGOXPO INTELLIGENCE
                    </div>

                    <h3
                      style={{
                        margin: "5px 0 0",
                        color: "#f8fafc",
                        fontSize: 22,
                        fontWeight: 900,
                      }}
                    >
                      ⚡ MEV BOT
                    </h3>

                    <div
                      style={{
                        marginTop: 5,
                        color: "#64748b",
                        fontSize: 11,
                      }}
                    >
                      Multi-chain MEV opportunity scanner
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "8px 13px",
                      borderRadius: 999,
                      background: userBotStatus?.active
                        ? "rgba(34,197,94,.10)"
                        : "rgba(148,163,184,.07)",
                      border: userBotStatus?.active
                        ? "1px solid rgba(34,197,94,.30)"
                        : "1px solid rgba(148,163,184,.16)",
                    }}
                  >

                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: userBotStatus?.active
                          ? "#22c55e"
                          : "#64748b",
                        boxShadow: userBotStatus?.active
                          ? "0 0 12px rgba(34,197,94,.8)"
                          : "none",
                      }}
                    />

                    <span
                      style={{
                        color: userBotStatus?.active
                          ? "#22c55e"
                          : "#94a3b8",
                        fontSize: 10,
                        fontWeight: 900,
                      }}
                    >
                      {userBotStatus?.active
                        ? "BOT ACTIVE"
                        : "BOT READY"}
                    </span>

                  </div>

                </div>

                {/* CHAIN CARDS */}

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(4,minmax(0,1fr))",
                    gap: 11,
                    padding: 16,
                  }}
                >

                  {CHAINS.map((chain) => {

                    const chainSignals =
                      getChainSignals(chain.name);

                    const bestSignal =
                      chainSignals[0];

                    return (
                      <div
                        key={chain.name}
                        style={{
                          minHeight: 125,
                          padding: 14,
                          borderRadius: 12,
                          background:
                            "linear-gradient(145deg,#0a1728,#030a14)",
                          border:
                            `1px solid ${chain.color}45`,
                        }}
                      >

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent:
                              "space-between",
                            marginBottom: 14,
                          }}
                        >

                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >

                            <img
                              src={chain.logo}
                              alt={chain.name}
                              width={25}
                              height={25}
                              style={{
                                objectFit: "contain",
                              }}
                            />

                            <strong
                              style={{
                                color: "#e2e8f0",
                                fontSize: 11,
                              }}
                            >
                              {chain.name}
                            </strong>

                          </div>

                          <span
                            style={{
                              color:
                                chainSignals.length
                                  ? "#22c55e"
                                  : "#64748b",
                              fontSize: 8,
                              fontWeight: 900,
                            }}
                          >
                            {chainSignals.length
                              ? "LIVE"
                              : "WAITING"}
                          </span>

                        </div>

                        <div
                          style={{
                            color: "#64748b",
                            fontSize: 9,
                          }}
                        >
                          OPPORTUNITIES
                        </div>

                        <div
                          style={{
                            marginTop: 4,
                            color: "#f8fafc",
                            fontSize: 23,
                            fontWeight: 900,
                          }}
                        >
                          {chainSignals.length}
                        </div>

                        <div
                          style={{
                            marginTop: 6,
                            color: "#64748b",
                            fontSize: 9,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {bestSignal
                            ? `${bestSignal.pair || "Signal"} • ${bestSignal.expectedProfit || 0}%`
                            : "Scanning market..."}
                        </div>

                      </div>
                    );

                  })}

                </div>

                {/* BOT FOOTER */}

                <div
                  style={{
                    margin: "0 16px 16px",
                    padding: 15,
                    borderRadius: 11,
                    background:
                      "linear-gradient(90deg,rgba(124,58,237,.11),rgba(37,99,235,.08))",
                    border:
                      "1px solid rgba(124,58,237,.18)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    flexWrap: "wrap",
                  }}
                >

                  <div>

                    <div
                      style={{
                        color: "#f8fafc",
                        fontSize: 12,
                        fontWeight: 900,
                      }}
                    >
                      MEV Advanced Strategy
                    </div>

                    <div
                      style={{
                        color: "#64748b",
                        fontSize: 9,
                        marginTop: 4,
                      }}
                    >
                      SOLANA • BSC • ETH • POLYGON
                    </div>

                  </div>

                  <button
                    type="button"
                    disabled={userBotStatus?.active}
                    onClick={() => {
                      if (!userBotStatus?.active) {
                        setModals({
                          ...modals,
                          bot: true,
                        });
                      }
                    }}
                    style={{
                      border: 0,
                      borderRadius: 9,
                      padding: "11px 17px",
                      background:
                        userBotStatus?.active
                          ? "#14532d"
                          : "linear-gradient(135deg,#7c3aed,#4f46e5)",
                      color: "#fff",
                      fontSize: 10,
                      fontWeight: 900,
                      cursor:
                        userBotStatus?.active
                          ? "default"
                          : "pointer",
                      boxShadow:
                        "0 8px 22px rgba(79,70,229,.25)",
                    }}
                  >
                    {userBotStatus?.active
                      ? "✓ BOT RUNNING"
                      : "ACTIVATE MEV BOT"}
                  </button>

                </div>

              </section>

              </div>

              {/* ================= LOWER GRID ================= */}
              <div className="ax-bottom-grid">

                {/* ROI */}
                <section
                  className="ax-panel ax-roi-panel"
                  id="ax-roi"
                >

                  <div className="ax-panel-title">
                    <h3>ROI PERFORMANCE</h3>

                    <div className="ax-roi-controls">
                      {["daily", "weekly", "monthly"].map((t) => (
                        <button
                          key={t}
                          className={`ax-roi-btn ${
                            roiType === t ? "active" : ""
                          }`}
                          onClick={() => {
                            setRoiType(t);
                            loadRoiGraph(t);
                          }}
                        >
                          {t}
                        </button>
                      ))}
                    </div>
                  </div>

                  <div style={{ width: "100%", height: 205 }}>
                    <ResponsiveContainer
                      width="100%"
                      height="100%"
                    >
                      <LineChart data={roiGraph}>
                        <CartesianGrid
                          strokeDasharray="3 3"
                          stroke="#14222b"
                        />

                        <XAxis
                          dataKey="label"
                          tick={{
                            fill: "#64748b",
                            fontSize: 8,
                          }}
                          axisLine={false}
                        />

                        <YAxis
                          tick={{
                            fill: "#64748b",
                            fontSize: 8,
                          }}
                          axisLine={false}
                        />

                        <Tooltip />

                        <Line
                          type="monotone"
                          dataKey="roi"
                          stroke="#39ff14"
                          strokeWidth={2}
                          dot={{
                            r: 3,
                            fill: "#39ff14",
                          }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>

                  <div
                    style={{
                      color: "#39ff14",
                      fontSize: 12,
                      fontWeight: 900,
                    }}
                  >
                    Total ROI: $
                    {Number(roiTotal || 0).toFixed(2)}
                  </div>

                </section>

                {/* TEAM */}
                <section className="ax-panel">

                  <div className="ax-panel-title">
                    <h3>TEAM OVERVIEW</h3>

                    <button
                      className="ax-view"
                      onClick={() =>
                        setModals({ ...modals, team: true })
                      }
                    >
                      View All
                    </button>
                  </div>

                  <div className="ax-team-grid">

                    <div className="ax-team-card">
                      <div className="ax-team-card-top">
                        <div className="ax-team-icon">
                          ♣
                        </div>

                        <div>
                          <div className="ax-team-label">
                            DIRECT MEMBERS
                          </div>

                          <div className="ax-team-value">
                            {directMembers.length}
                          </div>

                          <div className="ax-team-growth">
                            Active Directs
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ax-team-card">
                      <div className="ax-team-card-top">
                        <div className="ax-team-icon">
                          ♣
                        </div>

                        <div>
                          <div className="ax-team-label">
                            TEAM MEMBERS
                          </div>

                          <div className="ax-team-value">
                            {teamMembers.length}
                          </div>

                          <div className="ax-team-growth">
                            Total Team
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ax-team-card">
                      <div className="ax-team-card-top">
                        <div className="ax-team-icon">
                          $
                        </div>

                        <div>
                          <div className="ax-team-label">
                            TOTAL BUSINESS
                          </div>

                          <div className="ax-team-value">
                            $
                            {Number(
                              teamBusiness || 0
                            ).toFixed(2)}
                          </div>

                          <div className="ax-team-growth">
                            Team Business
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ax-team-card">
                      <div className="ax-team-card-top">
                        <div className="ax-team-icon">
                          ★
                        </div>

                        <div>
                          <div className="ax-team-label">
                            TEAM LEVEL
                          </div>

                          <div className="ax-team-value">
                            {level}
                          </div>

                          <div className="ax-team-growth">
                            Current Level
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </section>

                {/* TRANSACTIONS */}
                <section className="ax-panel">

                  <div className="ax-panel-title">
                    <h3>RECENT TRANSACTIONS</h3>

                    <button
                      className="ax-view"
                      onClick={() => {
                        setHistoryFilter("all");
                        setHistoryModalOpen(true);
                        loadHistory();
                      }}
                    >
                      View All
                    </button>
                  </div>

                  <div className="ax-transactions">

                    {recentTransactions.length ? (
                      recentTransactions.map((tx, i) => (
                        <div
                          className="ax-tx"
                          key={`${tx.type}-${tx.date}-${i}`}
                        >

                          <div
                            className={`ax-tx-icon ${tx.cls}`}
                          >
                            {tx.icon}
                          </div>

                          <div>
                            <div className="ax-tx-name">
                              {tx.type}
                            </div>

                            <div className="ax-tx-sub">
                              USDT
                              {" • "}
                              {tx.date
                                ? new Date(
                                    tx.date
                                  ).toLocaleString()
                                : "-"}
                            </div>
                          </div>

                          <div className="ax-tx-right">

                            <div
                              className={`ax-tx-amount ${
                                tx.positive
                                  ? "plus"
                                  : "minus"
                              }`}
                            >
                              {tx.positive ? "+" : "-"}$
                              {tx.amount.toFixed(2)}
                            </div>

                            <div
                              className={`ax-tx-status ${
                                String(tx.status)
                                  .toLowerCase()
                                  .includes("pending")
                                  ? "pending"
                                  : ""
                              }`}
                            >
                              {tx.status}
                            </div>

                          </div>

                        </div>
                      ))
                    ) : (
                      <div className="ax-empty">
                        No recent transactions.
                      </div>
                    )}

                  </div>

                </section>

              </div>

              {/* ================= AI BANNER ================= */}
              <div className="ax-ai-banner">

                <div>
                  <div className="ax-ai-eyebrow">
                    AI POWERED TRADING
                  </div>

                  <h3>
                    MAXIMIZE YOUR PROFITS
                  </h3>

                  <p>
                    Let our advanced AI algorithms trade for you
                    24/7 and maximize your returns.
                  </p>
                </div>

                <button
                  className="ax-ai-btn"
                  disabled={userBotStatus?.active}
                  onClick={() => {
                    if (!userBotStatus?.active) {
                      setModals({ ...modals, bot: true });
                    }
                  }}
                >
                  {userBotStatus?.active
                    ? "AI BOT ACTIVE"
                    : "ACTIVATE AI BOT NOW"}
                </button>

              </div>

              {/* ================= FOOTER ================= */}
              <div className="ax-footer">
                <span>
                  © 2026 AlgoXPO. All Rights Reserved.
                </span>

                <span>
                  ● &nbsp; Server Time:{" "}
                  {new Date().toLocaleString()}
                </span>

                <span>
                  AlgoXPO AI Trading Platform
                </span>
              </div>

            </div>
          </main>

        </div>
      </div>

      {/* ================= REFERRAL LINK ================= */}
      <div
        style={{
          background:
            "linear-gradient(135deg,#071522 0%,#0b1f2f 55%,#07101c 100%)",
          border: "1px solid rgba(34,197,94,.28)",
          borderRadius: 18,
          padding: 20,
          margin: "0 20px 20px",
          boxShadow: "0 12px 35px rgba(0,0,0,.25)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            flexWrap: "wrap",
            marginBottom: 14,
          }}
        >
          <div>
            <div
              style={{
                color: "#22c55e",
                fontSize: 12,
                fontWeight: 800,
                letterSpacing: 1,
              }}
            >
              REFERRAL PROGRAM
            </div>

            <h3
              style={{
                margin: "5px 0 3px",
                color: "#fff",
                fontSize: 20,
              }}
            >
              Your Referral Link
            </h3>

            <p
              style={{
                margin: 0,
                color: "#94a3b8",
                fontSize: 13,
              }}
            >
              Share your referral link and invite new members.
            </p>
          </div>

          <div
            style={{
              padding: "7px 12px",
              borderRadius: 20,
              background: "rgba(34,197,94,.10)",
              border: "1px solid rgba(34,197,94,.25)",
              color: "#22c55e",
              fontSize: 12,
              fontWeight: 800,
            }}
          >
            ID: {userId}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
            alignItems: "stretch",
            flexWrap: "wrap",
          }}
        >
          <input
            type="text"
            readOnly
            value={referralLink}
            style={{
              flex: 1,
              minWidth: 220,
              boxSizing: "border-box",
              padding: "13px 14px",
              borderRadius: 10,
              border: "1px solid #26364a",
              background: "#020617",
              color: "#cbd5e1",
              outline: "none",
              fontSize: 13,
            }}
          />

          <button
            type="button"
            onClick={() => {
              navigator.clipboard
                .writeText(referralLink)
                .then(() => alert("Referral link copied successfully!"))
                .catch(() => alert("Unable to copy referral link."));
            }}
            style={{
              minWidth: 105,
              padding: "13px 18px",
              border: "none",
              borderRadius: 10,
              background: "linear-gradient(135deg,#22c55e,#16a34a)",
              color: "#fff",
              fontWeight: 800,
              cursor: "pointer",
              boxShadow: "0 7px 20px rgba(34,197,94,.22)",
            }}
          >
            📋 Copy
          </button>
        </div>
      </div>

      

      {/* Modals */}
      {modals.deposit && (
        <DepositModal
          address={depositAddress}
          onClose={() => setModals({ ...modals, deposit: false })}
        />
      )}
      {modals.withdraw && (
        <WithdrawModal
          balance={earningBalance}
          onClose={() => {
            setModals({ ...modals, withdraw: false });
            setWithdrawSuccess(false);
          }}
          onSubmit={handleWithdraw}
        />
      )}

{/* 👇 YAHAN ADD KARO */}
{modals.transfer && (
  <TransferModal
    balance={earningBalance}
    onClose={() =>
      setModals({
        ...modals,
        transfer: false,
      })
    }
    onSubmit={handleTransfer}
  />
)}
      {modals.invest && (
        <InvestModal
          balance={walletBalance}
          onClose={() => setModals({ ...modals, invest: false })}
          onSubmit={handleInvest}
        />
      )}
      {modals.bot && (
        <BotActivationModal
          balance={walletBalance}
          onClose={() => setModals({ ...modals, bot: false })}
          onSubmit={handleBotActivation}
        />
      )}
      {modals.team && (
        <TeamModal
          directMembers={directMembers}
          teamMembers={teamMembers}
          onClose={() => setModals({ ...modals, team: false })}
        />
      )}
      <TradingViewTicker position="bottom" />
    </>
  );
}
